import { Component, ElementRef, HostListener, OnInit, OnDestroy, Output } from '@angular/core';
import { AllLinksComponent } from 'src/app/core/all-links/all-links.component';
import { LearnerService } from 'src/app/core/services/learner.service';
import { EventEmitter } from '@angular/core';
import { TemplateServiceService } from 'src/app/components/template-module/service/template-service.service'
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { PermissionService } from 'src/app/core/services/permission-service.service';
import { SidebarService } from 'src/app/core/services/sidebar.service';
import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'app-side-overlay-menu',
  templateUrl: './side-overlay-menu.component.html',
  styleUrls: ['./side-overlay-menu.component.css']
})

export class SideOverlayMenuComponent implements OnInit, OnDestroy {
  documents: any = [];
  desired_title = "Employee Handbook";
  file_url: string;
  isCollapsed: boolean = false;
  activeMenuKey: string | null = null;
  currentTooltip: HTMLElement | null = null;
  currentSubmenu: HTMLElement | null = null;
  hoveredSubmenuKey: string | null = null;
  submenuHoverTimeout: any = null;
  currentRoute: string = '';
  manuallyClosedMenus: Set<string> = new Set(); // Track manually closed menus

  documentRes: any
  @Output()
  notify: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  collapsedChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  type: any = 'document'
  showEsep: boolean = false;
  showNDCBtn: boolean = false;
  showExpense: boolean = false;
  showHrmanager: boolean = false;
  showPoa:boolean = false;
  showAmdoc:boolean = false;
  poaPermission: any;
  amdocPermission: any;
  offRoleManagerPermission:any;
  offRoleHrPermission:any;
  showHome:Boolean = false;
  showProfile:Boolean = false;
  showDocument:Boolean = false;
  showCircular:Boolean = false;
  showEmpHandbook:Boolean = false;
  showMemories:Boolean = false;
  showProduct:Boolean = false;
  showOnboarding:Boolean = false;
  templateNames: { id: string, name: string }[] = [];
  activeTemplateId: string | null = null;
  constructor(
    private learnerService: LearnerService,
    private permissionService: PermissionService,
    public allLink: AllLinksComponent,
    private templateservice: TemplateServiceService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private elementRef: ElementRef,
    private sidebarService: SidebarService
  ) {
    // Sync local state with service state
    this.sidebarService.collapsed$.subscribe(collapsed => {
      this.isCollapsed = collapsed;
    });
    
    // Clean up tooltips on route changes and track current route
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.currentRoute = event.urlAfterRedirects;
      this.updateActiveMenuFromRoute();
      this.hideTooltip();
      this.hoveredSubmenuKey = null;
      if (this.submenuHoverTimeout) {
        clearTimeout(this.submenuHoverTimeout);
      }
    });
    
    // Set initial route
    this.currentRoute = this.router.url;
    this.updateActiveMenuFromRoute();
  }

  ngOnInit(): void {
    this.templateservice.getTemplate(null).subscribe((response: any) => {
      let res = response.data
      // res.forEach()

      res.forEach(template => {
        //console.log('the template name is ', template.name)
        this.templateNames.push({ id: template.id, name: template.name });

      });
    });

    this.learnerService.getDocumentsList(this.type).subscribe(res => {
      //console.log(res);
      this.documents = res;
      this.documentRes = this.documents;
      this.notify.emit(this.documentRes);
      const matching_object = this.documents.find(item => item.title === this.desired_title);

      // Retrieve the "file" value if a matching object is found
      if (matching_object) {
        this.file_url = matching_object.file;
      } else {
        console.log("No match found for the given title.");
      }
    },
      (error: any) => {
        console.log(error, error.error, error.message);
      });


    this.permissionService.getEmployeePermissions()
    .pipe(
        filter(data => !!data),
        take(1)
    )
    .subscribe(empPerms => {
      //console.log(empPerms);
      if (empPerms) { 
        this.showExpense = empPerms.expense_manager;
        this.showHrmanager = empPerms.hr_manager;
        this.poaPermission = empPerms.poa_permission;
        this.amdocPermission = empPerms.amdoc_permission;
        this.offRoleManagerPermission=empPerms.is_offroll_manager;
        this.offRoleHrPermission=empPerms.hr_offroll_permission;

        if (this.poaPermission) {
          if (this.poaPermission.includes('ceo') || this.poaPermission.includes('view_all') || this.poaPermission.includes('poa') || this.poaPermission.includes('legal') || this.poaPermission === 'hod') {
            this.showPoa = true;

          }

        }

        if (this.amdocPermission) {
          this.showAmdoc = true
         // console.log('yes the permission for amdoc is given', this.amdocPermission)
        }

        this.showEsep = empPerms.e_separation;
        this.showNDCBtn = empPerms.ndc;
        this.showHome = empPerms.home;
        this.showProfile = empPerms.profile;
        this.showDocument =  empPerms.documents;
        this.showCircular = empPerms.circular_form;
        this.showEmpHandbook = empPerms.employee_handbook;
        this.showMemories = empPerms.memories;
        this.showProduct = empPerms.products;
        this.showOnboarding = empPerms.onboarding;
      }
    });
  }

  // for off role menu
   canViewOffRollMenu(): boolean {
      return !!(
        this.offRoleHrPermission === true ||
        this.offRoleManagerPermission === true
      );
    }

  handBookPdf() {
    this.learnerService.getViewDownloadPdf(this.file_url).subscribe(res => {
      this.documents = res;
      window.open(this.documents.presigned_url, "_blank");
    //   window.location.reload();
     },
      (error: any) => {
        console.log(error, error.error, error.message);
      });
  }
  logTemplateName(template: { id: string, name: string }) {
    this.activeTemplateId = template.id; // Set active template
    this.hideTooltip(); // Hide tooltip before navigation
    this.closeMenus();
    this.router.navigate(['/template/view_template'], {
      queryParams: {
        service_id: template.id,
        filter: 'total'

      }
    }).then(() => {
      // Reload the page after navigation
      window.location.reload();
    });
  }

  toggleSidebar(event: MouseEvent): void {
    event.stopPropagation();
    this.sidebarService.toggleCollapsed();
    if (this.isCollapsed) {
      this.closeMenus();
    }
    // Keep the existing output event for backward compatibility
    this.collapsedChange.emit(this.isCollapsed);
  }

  toggleMenu(key: string, event?: MouseEvent): void {
    if (event) {
      event.stopPropagation();
    }
    
    // Toggle the menu state
    if (this.activeMenuKey === key) {
      // Currently open, so close it
      this.activeMenuKey = null;
      this.manuallyClosedMenus.add(key);
    } else {
      // Currently closed, so open it
      this.activeMenuKey = key;
      this.manuallyClosedMenus.delete(key);
    }
    
    if (this.activeMenuKey === key && event && this.isCollapsed) {
      setTimeout(() => {
        this.positionFloatingSubmenu(event.currentTarget as HTMLElement);
      });
    }
  }

  onTooltipMouseEnter(event: MouseEvent, tooltipText: string): void {
    if (this.isCollapsed) {
      const target = event.currentTarget as HTMLElement;
      this.showTooltip(target, tooltipText);
    }
  }

  onTooltipMouseLeave(): void {
    this.hideTooltip();
  }

  private showTooltip(target: HTMLElement, text: string): void {
    this.hideTooltip();
    
    const tooltip = document.createElement('div');
    tooltip.className = 'dynamic-tooltip';
    tooltip.textContent = text;
    tooltip.style.cssText = `
      position: fixed;
      background: #333;
      color: #fff;
      padding: 8px 12px;
      border-radius: 6px;
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
      white-space: nowrap;
      z-index: 9999;
      font-size: 12px;
      opacity: 0;
      transition: opacity 0.3s ease;
    `;
    
    document.body.appendChild(tooltip);
    
    const rect = target.getBoundingClientRect();
    const sidebarWidth = this.isCollapsed ? 64 : 220;
    
    tooltip.style.left = `${sidebarWidth + 8}px`;
    tooltip.style.top = `${rect.top + rect.height / 2}px`;
    tooltip.style.transform = 'translateY(-50%)';
    
    setTimeout(() => tooltip.style.opacity = '1', 10);
    this.currentTooltip = tooltip;
  }

  public hideTooltip(): void {
    if (this.currentTooltip) {
      this.currentTooltip.remove();
      this.currentTooltip = null;
    }
  }

  isMenuOpen(key: string): boolean {
    // If user manually closed this menu, respect that choice
    if (this.manuallyClosedMenus.has(key)) {
      return false;
    }
    
    // Keep HR menu open when on HR pages and not collapsed
    if (key === 'hr' && !this.isCollapsed && this.currentRoute.includes('/hr-manager/')) {
      return true;
    }
    return this.activeMenuKey === key;
  }

  closeMenus(): void {
    this.activeMenuKey = null;
    // Also hide tooltips when closing menus
    this.hideTooltip();
  }

  onSubmenuHover(key: string, event: MouseEvent): void {
    if (this.isCollapsed) {
      // Clear any existing timeout
      if (this.submenuHoverTimeout) {
        clearTimeout(this.submenuHoverTimeout);
      }
      
      this.hoveredSubmenuKey = key;
      // Position submenu immediately
      this.positionFloatingSubmenu(event.currentTarget as HTMLElement);
    }
  }

  onSubmenuHoverLeave(key: string): void {
    if (this.isCollapsed) {
      // Set timeout to close submenu if mouse doesn't enter submenu area
      this.submenuHoverTimeout = setTimeout(() => {
        if (this.hoveredSubmenuKey === key) {
          this.hoveredSubmenuKey = null;
        }
      }, 150); // Small delay to allow mouse to move to submenu
    }
  }

  onFloatingSubmenuEnter(): void {
    // Clear timeout when mouse enters floating submenu
    if (this.submenuHoverTimeout) {
      clearTimeout(this.submenuHoverTimeout);
    }
  }

  onFloatingSubmenuLeave(key: string): void {
    // Close submenu when mouse leaves floating submenu
    if (this.hoveredSubmenuKey === key) {
      this.hoveredSubmenuKey = null;
    }
  }

  private positionFloatingSubmenu(menuElement: HTMLElement): void {
    setTimeout(() => {
      const floatingSubmenu = document.querySelector('.floating-submenu') as HTMLElement;
      if (floatingSubmenu && menuElement) {
        const rect = menuElement.getBoundingClientRect();
        floatingSubmenu.style.top = `${rect.top}px`;
      }
    }, 0);
  }

  isSubmenuHovered(key: string): boolean {
    return this.hoveredSubmenuKey === key;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const sideMenuElement = this.elementRef.nativeElement.querySelector('.side-menu');
    
    // Check if click is outside the main sidebar and floating submenus
    if (sideMenuElement && !sideMenuElement.contains(target)) {
      // Check if clicked on floating submenu
      const floatingMenus = document.querySelectorAll('.floating-submenu');
      let clickedOnFloatingMenu = false;
      
      floatingMenus.forEach(menu => {
        if (menu.contains(target)) {
          clickedOnFloatingMenu = true;
        }
      });
      
      if (!clickedOnFloatingMenu) {
        this.closeMenus();
      }
    }
  }
  
  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(event: KeyboardEvent): void {
    this.closeMenus();
    this.hideTooltip(); // Also hide tooltips on escape
  }

  // Update active menu based on current route
  private updateActiveMenuFromRoute(): void {
    // Check if current route is an HR Manager page
    if (this.currentRoute.includes('/hr-manager/')) {
      // Only auto-open if not manually closed
      if (!this.manuallyClosedMenus.has('hr')) {
        this.activeMenuKey = 'hr';
      }
    } else {
      // Clear manual close state when leaving HR section
      this.manuallyClosedMenus.delete('hr');
    }

    // Check if current route is template page
    if (this.currentRoute.includes('/template/view_template')) {
      // Get service_id from query params
      this.activatedRoute.queryParams.subscribe(params => {
        if (params['service_id']) {
          this.activeTemplateId = params['service_id'];
        }
      });
    } else {
      // Clear active template when leaving template section
      this.activeTemplateId = null;
    }
  }

  ngOnDestroy(): void {
    // Cleanup all tooltips and timers
    this.hideTooltip();
    this.cleanupAllTooltips();
    if (this.submenuHoverTimeout) {
      clearTimeout(this.submenuHoverTimeout);
    }
    this.hoveredSubmenuKey = null;
  }

  private cleanupAllTooltips(): void {
    // Remove all dynamic tooltips that might be left behind
    const existingTooltips = document.querySelectorAll('.dynamic-tooltip');
    existingTooltips.forEach(tooltip => tooltip.remove());
  }
}

